import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';


@Pipe({name: 'bgImage'})
export class BgImagePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(url: string, bypassSecurity: boolean = true): SafeStyle {
    if (bypassSecurity) {
      return this.sanitizer.bypassSecurityTrustStyle(`url("${(url)}")`);
    } else {
      return `url("${(url)}")`;
    }
  }
}
